import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { FparTableCellIssue } from '@core/models';

@Component({
  selector: 'app-fpar-sub-issue',
  templateUrl: './fpar-sub-issue.component.html',
  styleUrls: ['./fpar-sub-issue.component.scss'],
  standalone: true,
  imports: [CommonModule, MatAccordion, MatExpansionModule, MatIconModule],
})
export class FparSubIssueComponent {
  @Input() canResolve = false;
  @Input() flatDisplay = false;
  @Input() subIssues: FparTableCellIssue[] = [];
  @Output() activateSubIssue = new EventEmitter<FparTableCellIssue>();
  public panelOpen = false;

  public setActiveSubIssue(subIssue: FparTableCellIssue, $event: Event): void {
    $event.preventDefault();
    document
      .getElementById(`${subIssue.columnId}-${subIssue.rowId}`)
      .scrollIntoView({ behavior: 'smooth', block: 'center' });

    this.activateSubIssue.emit(subIssue);
  }
}
